var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.05 12.3034C23.051 10.1227 22.4052 7.99066 21.1944 6.17695C19.9835 4.36324 18.262 2.9493 16.2476 2.11408C14.2331 1.27886 12.0162 1.05985 9.87722 1.48468C7.73825 1.90952 5.77329 2.95912 4.23092 4.5008C2.68854 6.04247 1.63802 8.00692 1.21221 10.1457C0.786402 12.2845 1.00446 14.5015 1.83877 16.5163C2.67307 18.5311 4.08618 20.2534 5.89934 21.465C7.7125 22.6767 9.84426 23.3234 12.025 23.3234C14.9478 23.3224 17.7507 22.1612 19.8179 20.0949C21.8851 18.0286 23.0476 15.2262 23.05 12.3034Z",
    stroke: "#2B2A29",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27539 8.55273L15.7754 16.0527",
    stroke: "#2B2A29",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7754 8.55273L8.27539 16.0527",
    stroke: "#2B2A29",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.d61a76545ba96e9c1fce52ed84d7e5ce.svg";
export { ForwardRef as ReactComponent };